// ============================================================================
// Contrôles avant publication d'une SKILLCARD (spec § 19).
// ============================================================================
// Miroir UX des gardes serveur (CHECK SQL + RPC `publish_card`) : le serveur
// reste seul juge, ce module sert à désactiver le bouton et à dire POURQUOI.
// ============================================================================

import { estimateCardFit } from './fit';
import { hasUnbalancedMath } from './math-text';
import type { CardContent, CardStatus } from './schemas';

export interface CardPublishInput {
  title: string;
  cardType: string | null;
  subject: string | null;
  levels: readonly string[];
  content: CardContent;
  /** HORA max CALCULÉ depuis les exercices reliés (migration 0508) : plus contrôlé ici. */
  xpMax: number;
  status: CardStatus;
  /** Le tuteur a coché « J'ai relu et je valide le contenu généré ». */
  reviewed: boolean;
}

export function cardPublishIssues(card: CardPublishInput): string[] {
  const issues: string[] = [];
  if (!card.title.trim()) issues.push('Ajoute un titre.');
  else if (hasUnbalancedMath(card.title))
    issues.push(
      'Le titre contient un « $ » non fermé : écris chaque formule entre deux $ (ex. $\\cos^2 x$).',
    );
  if (!card.cardType) issues.push('Choisis le type de carte.');
  if (!card.subject) issues.push('Choisis la matière.');
  if (card.levels.length === 0) issues.push('Choisis au moins un niveau.');
  if (card.content.sections.length === 0)
    issues.push('Le recto est vide : génère ou ajoute du contenu.');
  if (card.status === 'archived')
    issues.push('La carte est archivée : restaure-la avant de publier.');
  if (!card.reviewed && card.status !== 'review' && card.status !== 'published') {
    issues.push('Relis le contenu et coche « J’ai relu et je valide ».');
  }
  return issues;
}

/**
 * Avertissements NON bloquants : un recto qui déborde se publie quand même
 * (il défile en ligne ; imprimé, il est coupé avec « Suite en ligne »).
 */
export function cardPublishWarnings(card: Pick<CardPublishInput, 'title' | 'content'>): string[] {
  return estimateCardFit(card.title, card.content) === 'overflow'
    ? [
        'Le recto déborde de la carte (63 × 88) : en ligne il défile, imprimé il sera coupé (« Suite en ligne »). Raccourcis-le si tu peux.',
      ]
    : [];
}
